// Exportar TODA la cartera pide el PIN (auditoría de seguridad 2026-09-27,
// punto 4). Antes bastaba con pulsar Excel/CSV: una cuenta robada —o un
// asiento— se llevaba hasta 10.000 fichas con fecha de nacimiento y estatus
// migratorio en un clic. El servidor decide (PIN, permiso del asiento, 5 por
// hora, registro obligatorio); esto solo pregunta y explica.
import { useState } from 'react';
import { Lock, ShieldAlert } from 'lucide-react';
import { Modal } from './ui.jsx';

export function ExportarClientesModal({ lang, count, formato, onConfirm, onClose }) {
  const es = lang === 'es';
  const [pin, setPin] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [err, setErr] = useState(null);

  const enviar = async (e) => {
    e?.preventDefault();
    if (ocupado) return;
    if (pin.length !== 6) { setErr(es ? 'El PIN debe tener 6 dígitos' : 'PIN must be 6 digits'); return; }
    setErr(null); setOcupado(true);
    try {
      await onConfirm(pin);
      onClose();
    } catch (e2) {
      const quedan = typeof e2.remainingAttempts === 'number' ? e2.remainingAttempts : null;
      if (e2.code === 'PIN_WRONG') setErr((es ? 'PIN incorrecto.' : 'Incorrect PIN.') + (quedan != null ? (es ? ` Te quedan ${quedan} intentos.` : ` ${quedan} attempts left.`) : ''));
      else if (e2.code === 'PIN_NOT_SET') setErr(es ? 'No hay PIN configurado. Configúralo en Mi Perfil → Seguridad.' : 'No PIN configured. Set one in My Profile → Security.');
      else if (e2.code === 'PIN_LOCKED') setErr(es ? 'Demasiados intentos. Espera 15 minutos.' : 'Too many attempts. Wait 15 minutes.');
      else if (e2.code === 'EXPORT_NOT_ALLOWED') setErr(es ? 'Tu agente no te ha dado permiso para exportar clientes.' : 'Your agent has not allowed you to export clients.');
      else if (e2.code === 'EXPORT_RATE_LIMITED') setErr(es ? 'Ya exportaste 5 veces en la última hora. Inténtalo más tarde.' : 'You already exported 5 times in the last hour. Try again later.');
      else setErr(e2.message);
      setPin('');
    } finally {
      setOcupado(false);
    }
  };

  return (
    <Modal title={es ? `Exportar clientes (${formato === 'csv' ? 'CSV' : 'Excel'})` : `Export clients (${formato === 'csv' ? 'CSV' : 'Excel'})`} onClose={onClose}>
      <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ fontSize: '.82rem', color: 'var(--c-amber,#ffb700)', background: 'rgba(255,183,0,.1)', border: '1px solid rgba(255,183,0,.28)', borderRadius: 8, padding: '.7rem .85rem', lineHeight: 1.55, display: 'flex', gap: '.6rem', alignItems: 'flex-start' }}>
          <ShieldAlert size={16} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>{es
            ? `El archivo tendrá ${count} cliente${count === 1 ? '' : 's'} con datos personales (teléfono, correo, dirección, fecha de nacimiento, estatus migratorio). Guárdalo donde solo tú entres y bórralo cuando ya no lo necesites.`
            : `The file will contain ${count} client${count === 1 ? '' : 's'} with personal data (phone, email, address, date of birth, immigration status). Keep it somewhere only you can reach and delete it when no longer needed.`}</span>
        </div>
        <div style={{ fontSize: '.8rem', color: 'var(--c-text2,#7aa3c0)', display: 'flex', gap: '.6rem', alignItems: 'flex-start', lineHeight: 1.5 }}>
          <Lock size={15} style={{ color: 'var(--c-cyan,#00d4ff)', flexShrink: 0, marginTop: 2 }} />
          <span>{es
            ? 'Escribe tu PIN de 6 dígitos. Queda registrado quién exportó y cuándo, y la dueña de la agencia recibe un aviso.'
            : 'Enter your 6-digit PIN. Who exported and when is recorded, and the agency owner is notified.'}</span>
        </div>
        <input
          value={pin}
          onChange={(e) => setPin(String(e.target.value || '').replace(/\D/g, '').slice(0, 6))}
          type="password" inputMode="numeric" autoComplete="off" placeholder="••••••" autoFocus
          style={{ width: '100%', boxSizing: 'border-box', background: 'var(--c-surface2,#112538)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 8, padding: '10px 14px', color: 'var(--c-white,#eef6ff)', fontSize: '1.1rem', letterSpacing: '.35em', textAlign: 'center', outline: 'none', fontFamily: 'var(--font-mono)' }}
        />
        {err && <div style={{ color: 'var(--c-red,#ff3d6b)', fontSize: '.8rem' }}>{err}</div>}
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} className="dkt-btn-g">{es ? 'Cancelar' : 'Cancel'}</button>
          <button type="submit" disabled={ocupado} className="dkt-btn-p">{ocupado ? (es ? 'Exportando…' : 'Exporting…') : (es ? 'Exportar' : 'Export')}</button>
        </div>
      </form>
    </Modal>
  );
}
